import { IApplicationState } from '../../types/redux';

export const getIsNextStepAvailable = (state: IApplicationState): boolean => {
  return Boolean(state.newAnswer.data.answer);
};
